import * as React from "react";
import { useTranslation } from "react-i18next";
import { useParams, Link, useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import axios from "axios";
import { setLoading } from "../../redux/loading/actions";
import { useDispatch, useSelector } from "react-redux";
import NavBar from "../../components/NavBar";
import Grid from "@mui/material/Grid";
import Bazar from "../../assets/img/bazar.png";
import Myket from "../../assets/img/myket.png";
import Drone from "../../assets/img/drone.png";
import Rahgiri from "../../assets/img/rahgiri.png";
import WebApp from "../../assets/img/webapp.png";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { ThemeContext } from "../../App";
import { Stack } from "@mui/material";
import "./style.css";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function Track() {
  const { t } = useTranslation();
  const muiTheme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selector = useSelector((st) => st);
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  let { code } = useParams();
  const [listTracking, setListTracking] = React.useState([]);
  const [listInfoTracking, setListInfoTracking] = React.useState([]);
  const theme = React.useContext(ThemeContext);
  const isSmUp = useMediaQuery(muiTheme.breakpoints.up("sm"));

  React.useEffect(() => {
    const _code = code.split("&")[0];
    handleTracking(_code);
  }, [code]);

  const handleTracking = async (e) => {
    dispatch(setLoading(true));
    try {
      let fetch = await axios({
        method: "GET",
        url: "https://postex.ir/api/geTracking",
        headers: {},
        params: {
          trackingNumber: e,
          token: "07b44357fb514837bd6afadfa448dece",
        },
      });

      if (fetch?.data?.IsSuccess) {
        const list = fetch?.data?.Data
          ? JSON.parse(fetch?.data?.Data[0]?.AllState)
          : [];
        setListTracking(fetch?.data?.Data || []);
        setListInfoTracking(list);
      } else {
        enqueueSnackbar(fetch?.data?.Message, {
          variant: "error",
          TransitionProps: {
            direction: "down",
          },
          anchorOrigin: {
            horizontal: "center",
            vertical: "top",
          },
        });
      }
      dispatch(setLoading(false));
    } catch (e) {
      dispatch(setLoading(false));
      console.log("error", e);
    }
  };

  return (
    <>
      {selector?.loading?.isLoading && (
        <div className="backdrop-loading">
          <div className="backdrop-bg">
            <div
              className="loader"
              style={
                theme.darkMode
                  ? { backgroundImage: "url('/splash2.gif')" }
                  : { backgroundImage: "url('/splash1.gif')" }
              }
            />
          </div>
        </div>
      )}

      <NavBar />

      <div className="track-page">
        <div className="container">
          {/*<div className="logo">*/}
          {/*  <NavLink to=''>*/}
          {/*    <img src={process.env.REACT_APP_SITE === 'amnito' ? '/amnito.png' : '/Logo.png'} alt="Logo" loading="lazy"/>*/}
          {/*  </NavLink>*/}
          {/*</div>*/}

          <div className="main-title">
            <p>
              {t("homeDesktop.s1.t18")}
              <span>{t("homeDesktop.s1.t19")}</span>
            </p>
            <span>
              {t("homeDesktop.s1.t20")}
              <p>{t("homeDesktop.s1.t21")}!</p>
            </span>
          </div>

          <div className="description">
            <p>{t("homeDesktop.s1.t2")}</p>
          </div>

          <Divider className="mb-4" />
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <div className="row mb-1">
                <div className="col-12">
                  <div className="itemTracking">
                    <p>{t("homeDesktop.s1.t26")} :</p>
                    <span>{listTracking[0]?.TrackingNumber}</span>
                  </div>
                </div>
                <div className="col-12 ">
                  <div className="itemTracking">
                    <p>{t("homeDesktop.s1.t8")} :</p>
                    <span>{listTracking[0]?.NameServiceProvider}</span>
                  </div>
                </div>
                {listInfoTracking?.map((item, index) => {
                  return (
                    <div className="col-12">
                      <div className="itemTracking">
                        <span>{index + 1}</span>
                        <div>
                          {item?.desc.split("،").map((item2) => (
                            <p>{item2}</p>
                          ))}
                        </div>
                        <span>{item?.date}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="row">
                <div className="col-12 col-md-6 mb-3">
                  <div className="btnGroup_yellow m-0">
                    <Link
                      to={{
                        pathname: "/singleOrder",
                        search: location?.search,
                      }}
                      type="button"
                      className="btnFill justify-content-center"
                      id="singleOrder"
                    >
                      {t("homeMobile.t30")}
                    </Link>
                  </div>
                </div>

                <div className="col-12 col-md-6 mb-3">
                  <div className="btnGroup_light m-0">
                    <Link
                      to={{ pathname: "/tracking", search: location?.search }}
                      type="button"
                      className="btnEmpty w-100 justify-content-center w-100"
                      id="tracking"
                    >
                      {t("homeMobile.t1")}
                    </Link>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="row">
                <div className="col-12">
                  <Card
                    sx={{
                      backgroundColor: "#E3F2FD",
                      boxShadow: "none",
                      marginBottom: "10px",
                      padding: "32px",
                    }}
                  >
                    <Grid container flexDirection={"row"}>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        justifyContent={isSmUp ? "" : "center"}
                      >
                        <Stack
                          flexDirection={isSmUp ? "row" : "column"}
                          alignItems={isSmUp ? "" : "center"}
                        >
                          <p className="track_title  ">
                            {t("homeDesktop.s1.t41")}
                            <span className=" track_title-bold  ">
                              {t("homeDesktop.s1.t44")}
                            </span>
                            {t("homeDesktop.s1.t45")}
                          </p>
                        </Stack>
                        <p
                          className="track_description"
                          style={{
                            display: "flex",
                            justifyContent: isSmUp ? "" : "center",
                            marginBottom: "20px",
                          }}
                        >
                          {t("homeDesktop.s1.t46")}
                        </p>
                      </Grid>
                      <Grid
                        sm={6}
                        item
                        xs={12}
                        display={"flex"}
                        alignItems={"flex-end"}
                        justifyContent={isSmUp ? "flex-end" : "center"}
                      >
                        <img
                          src={Drone}
                          style={isSmUp ? {} : { maxWidth: "250px" }}
                          className="track_rahgiri"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Divider className="mb-4" />
                      </Grid>
                      <Grid
                        justifyContent={"center"}
                        display={"flex"}
                        item
                        sm={6}
                        xs={12}
                        mb={1}
                      >
                        <img
                          onClick={() => {
                            window.open(
                              "https://l.postex.ir/61L9IUA",
                              "_blank"
                            );
                          }}
                          src={Bazar}
                          className="track_img-postex"
                        />
                      </Grid>
                      <Grid
                        justifyContent={"center"}
                        display={"flex"}
                        item
                        sm={6}
                        xs={12}
                        mb={1}
                      >
                        <Box
                          sx={{
                            width: "148px",
                            backgroundColor: "#FF5722",
                            borderRadius: "6px",
                            height: "42px",
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                          }}
                          onClick={() => {
                            navigate("/singleOrder", { replace: true });
                          }}
                        >
                          <p className="track_img-postex track_order">
                            {t("homeDesktop.s1.t47")}
                          </p>
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                </div>
                <div className="col-12">
                  <Card
                    sx={{
                      backgroundColor: "#FFF3E0",
                      boxShadow: "none",
                      padding: "32px 32px 0px 32px",
                      marginBottom: "10px",
                    }}
                  >
                    <Grid container flexDirection={"row"}>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        justifyContent={isSmUp ? "" : "center"}
                      >
                        <Stack
                          flexDirection={isSmUp ? "row" : "column"}
                          alignItems={isSmUp ? "" : "center"}
                        >
                          <p className="track_title  ">
                            {t("homeDesktop.s1.t41")}
                            <span className=" track_title-bold  ">
                              {t("homeDesktop.s1.t42")}
                            </span>
                          </p>
                        </Stack>
                        <p
                          className="track_description"
                          style={{
                            display: "flex",
                            justifyContent: isSmUp ? "" : "center",
                          }}
                        >
                          {t("homeDesktop.s1.t43")}
                        </p>
                        <Stack
                          spacing={2}
                          alignItems={isSmUp ? "" : "center"}
                          sx={{ marginTop: "16px", mb: "24px" }}
                        >
                          <img
                            src={Bazar}
                            onClick={() => {
                              window.open(
                                "https://l.postex.ir/61L9IUA",
                                "_blank"
                              );
                            }}
                            className="track_img"
                          />
                          <img
                            src={Myket}
                            onClick={() => {
                              window.open(
                                "https://l.postex.ir/5uVB6XG",
                                "_blank"
                              );
                            }}
                            className="track_img"
                          />
                          <img
                            src={WebApp}
                            onClick={() => {
                              window.open(
                                "https://rahgiri.postex.ir",
                                "_blank"
                              );
                            }}
                            className="track_img"
                          />
                        </Stack>
                      </Grid>
                      <Grid
                        sm={6}
                        item
                        xs={12}
                        justifyContent={isSmUp ? "flex-end" : "center"}
                        display={"flex"}
                        alignItems={"flex-end"}
                      >
                        <img
                          style={isSmUp ? {} : { maxWidth: "250px" }}
                          src={Rahgiri}
                          className="track_rahgiri"
                        />
                      </Grid>
                    </Grid>
                  </Card>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
}
